// Session state
export enum DIALOG_STATUS {
  PENDING = 0, //In progress
  ENDING = 1, //Ended
  QUEUEING = 2, //In line
  PREDONE = 3, //Pre-end
  TRANSFERING = 4, //Seat transfer
  HOLDON = 5, //Seat hosting
}

/**
 *
 * 0: In manual session
 * 1: in manual session
 * 2: robot session
 * 3: offline session
 */
export enum DIALOG_TYPE {
  AGENT = 0, //In a manual conversation
  TRANING = 1, //Transfer to manual queuing
  ROBOT = 2, //Robot conversation
  OFFLINE = 3, //Offline session
}

// Message sending type
export enum SEND_TYPE {
  USER = '0', //Messages from users
  AGENT = '1', //Messages from real agents
  ESCROW_AGENT = '2', //Message from the hosting agent
  ROBOT_AGENT = '3', //Message from the robot agent
  SYSTEM = '4', //System message
}

/**
 * Put (AGENT_TO_SKILL, "manual to skill queue");
 * put (ROBOT_TO_AGENT, "robot to labor");
 * put (ROBOT_TO_OFFLINE, "robot to offline robot");
 * put (OFFLINE_TO_AGENT, "offline robot to labor");
 * put (TRANSFER_SPECIFY_AGENT, "Go to designated seat");
 * put (CLASSIFICATION_TRANSFER, "classification transfer");
 * put (ROBOT_TO_SKILL, "robot to skill");
 * put (KEY_WORD_TRANSFER, "keyword transfer");
 * put (ROBOT_TO_NOTE, "Robot to message form");
 */

// Transfer labor type
export enum TRANSFER_TYPE {
  AGENT_TO_SKILL = '0', //Automatic to manual
  ROBOT_TO_AGENT = '1', //Robot to manual
  ROBOT_TO_OFFLINE = '2', //Robot Offline Robot
  OFFLINE_TO_AGENT = '3', //Offline robot to manual
  TRANSFER_SPECIFY_AGENT = '4', //Go to designated seat
  CLASSIFICATION_TRANSFER = '5', //Classification transfer
  ROBOT_TO_SKILL = '6', // Robot to skill
  KEY_WORD_TRANSFER = '7', //Match to keyword to manual
  ROBOT_TO_NOTE = '8', //Robot to message form
}

export enum USER_STATUS {
  Online = 0,
  Leave = 1,
}
